import { APINames } from 'src/shared';
import { isValidBase64, reportErrorLog, isString } from '../../utils';
// base64ToArrayBuffer
export function base64ToArrayBuffer(base64String: string) {
  if (!isString(base64String)) {
    reportErrorLog(
      APINames.Native.BASE64_TO_ARRAYBUFFER,
      `parameter error: parameter base64 type not legal, please check it.`,
    );
    return;
  }
  if (!isValidBase64(base64String)) {
    reportErrorLog(
      APINames.Native.BASE64_TO_ARRAYBUFFER,
      `parameter base64 ${base64String} is invalid base64 string`
    );
    return;
  }
  // 解码Base64字符串并转成ArrayBuffer
  const binaryString = atob(base64String);
  const len = binaryString.length;
  // 将Uint8Array转换为ArrayBuffer
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binaryString.charCodeAt(i);
  }
  return buffer;
}
